document.addEventListener('alpine:init', () => {
    
    


    Alpine.store('uploadStore', {
      uploadFilesToServer(uploadObj) {
        const {files,action, type, imageType, originalFile,cropperData, colorType} = uploadObj;

        const canvasStore = Alpine.store('canvas');
        const formData = new FormData();
        formData.append('configuratorId', canvasStore.configuratorId)
        imageType && formData.append('imageType', imageType)
        cropperData && formData.append('cropperData[]', JSON.stringify(cropperData));
        originalFile && formData.append('originalFiles[]', originalFile);
        for (const file of files) {
            formData.append(type, file) // appending every file to formdata
            if(type === 'hexCode') {
              formData.append('colorType', colorType)
            }
        }

        console.log(formData.get('backgrounds'))

        if(type === 'hexCode') {
          canvasStore.isColorBlockLoaderVisible = true;
        } else {
          canvasStore.isServerLoaderTabVisible = true;
        }
        
        return fetch(action, {
            method: "POST",
            body: formData,
            // "timeout": 0,
            headers: {
                "Authorization": `Bearer ${window.apiInfo[window.apiTestMode].token}`,
            },
            redirect: 'follow'
        })
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            canvasStore.isServerLoaderTabVisible = canvasStore.isColorBlockLoaderVisible = false;
            canvasStore.configuratorId = data.data.configuratorId;
            console.log(data);
            return data;
        })
        .catch((error) => {
            canvasStore.isServerLoaderTabVisible = canvasStore.isColorBlockLoaderVisible = false;
            console.error(error);
        });

      },
      updateImageInServer(editUploadObj) { 
        const {files, action, type, cropperData} = editUploadObj;
        const canvasStore = Alpine.store('canvas');
        const formData = new FormData();
        cropperData && formData.append('cropperData', JSON.stringify(cropperData));
        
        for (const file of files) {
            formData.append(type, file) // appending every file to formdata
        }

        canvasStore.isServerLoaderTabVisible = true;
        
        return fetch(action, {
            method: "POST",
            body: formData,
            // "timeout": 0,
            headers: {
                "Authorization": `Bearer ${window.apiInfo[window.apiTestMode].token}`,
            },
            redirect: 'follow'
        })
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            canvasStore.isServerLoaderTabVisible = false;
            
            console.log(data);
            return data;
        })
        .catch((error) => {
            canvasStore.isServerLoaderTabVisible = false;
            console.error(error);
        });
      },
        

      deleteFilesFromServer(id, type,fileName) {
          const canvasStore = Alpine.store('canvas');
          const formData = new FormData();
          formData.append('productId', this.$store.canvas.buganoProductId)
          formData.append('fileID', id)
          formData.append('fileName', fileName)
          formData.append('type', type)

          canvasStore.isServerLoaderTabVisible = true;

          return fetch('http://localhost:6288/delete', {
              method: "DELETE",
              body: formData,
          })
          .then((response) => {
              return response.json()
          })
          .then((data) => {
              canvasStore.isServerLoaderTabVisible = false;
              console.log(data);
              return data;
          })
          .catch((error) => {
              console.error(error);
          });
      }
    })
  
    Alpine.store('cropperStore', {
      cropImage: null,
      cropperData: null,
      originalImageFile: null,
      editingImageId: null,
      shouldPushRounded: false,
      uploadWithoutConfig: false,
      fileType: '',
      currentEl: null,


      async editExistingImage(image, fileType, el) {
        this.editingImageId = image.id;
        const cropperInitObj = {
          fileName: image.name,
          //url: background.cropperData.originalFileDataUrl,
          url: image.originalUrl || image.cropperData.originalFileDataUrl,
          cropperData: image.cropperData,
          fileType: fileType,
          el: el
        }
        this.prepareCropperImage(cropperInitObj);
      },
      async prepareCropperImage(cropperInitObj) {
            window.dispatchEvent(new CustomEvent(`cropper-init`))

            

            
            const img = document.createElement('img');
            img.id = 'js-cropper';
            
            
            img.alt = cropperInitObj.fileName;
            const imgcrop = document.getElementById('imgcrop'); 
            imgcrop.innerHTML = '';
            imgcrop.appendChild(img);

            
            

            img.src = cropperInitObj.url;

            // this represents current background image element which was created from file above 
            this.cropImage = img;
            this.cropperData = cropperInitObj.cropperData;
            if(cropperInitObj.originalImageFile) {
              this.originalImageFile = cropperInitObj.originalImageFile;
            }

            this.fileType= cropperInitObj.fileType;
            this.currentEl = cropperInitObj.el;

            this.uploadWithoutConfig = cropperInitObj.uploadWithoutConfig;

            
            //open modal if not open and if alreddy open then init background cropper
              if (document.querySelector("#cropModal").classList.contains('show')) {
                  this.initCropper(img)
              } else {
                bootstrap.Modal.getOrCreateInstance(document.querySelector('#cropModal')).show()
              }
           
          
      },



      averageBrightness: 255,
      async getAverageBrightness(url) {
        return new Promise(resolve => {
            const img = document.createElement('img');
            img.crossOrigin  = 'anonymous';
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, img.width, img.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                let totalBrightness = 0;
                let count = 0;
    
                for(let i = 0; i < imageData.data.length; i += 4) {
                    const r = imageData.data[i];
                    const g = imageData.data[i + 1];
                    const b = imageData.data[i + 2];
                    const a = imageData.data[i + 3];

                     // Skip transparent pixels
                    if(a === 0) continue;

                    totalBrightness += (r * 299 + g * 587 + b * 114) / 1000;
                    count++;
                }
    
                resolve(totalBrightness / count);
            };
            img.src = url;
        });
      },
      async updateAverageBrightness(url) {
        this.averageBrightness = await this.getAverageBrightness(url)
      },


      initCropper(img) {
        let self = this;
        this.currentEl.value = '';

        let cropperPreviewEL = document.querySelector('.js-img-cropper-preview');

        window.dispatchEvent(new CustomEvent(`${this.fileType}-cleard`))

        //destroy old cropper before initializing new one
        this.destroyCropper() 

        new Cropper(img, {
            crop: function (event) {
                self.cropBoxWidth = Math.round(event.detail.width);
                self.cropBoxHeight = Math.round(event.detail.height);
            },
            //aspectRatio: 1,
            autoCropArea: 1,
            preview: cropperPreviewEL,
            ready: function () {
                if(self.cropperData) {

                    if(self.cropperData.aspectRatio) {
                        self.setAspectRatio(self.cropperData.aspectRatio);
                    }
                    
                    if(self.cropperData.shouldPushRounded) {
                        self.setRadius();
                    } else {
                        self.setSquare();
                    }
                    
                    if(self.cropperData.zoomMode) {
                        self.zoomMode = self.cropperData.zoomMode;
                    }
                    if(self.cropperData.dragMode) { 
                        self.setDragMode(self.cropperData.dragMode);
                    }
                    
                    this.cropper.setData(self.cropperData);
                } else {
                    self.resetCropperControls()
                }
            },
        });

        if(this.fileType === 'backgrounds') {
          this.updateAverageBrightness(img.src)

        }

        //this.updateAverageBrightness(img.src)

      },
      cropBoxWidth: 0,
      cropBoxHeight: 0,
      resetCropperControls() {
        // except zoomMode all other methods sync the data in alpine and also
        // associated settings in croppper instance
        this.setAspectRatio('1');
        this.setSquare();
        this.setDragMode('move');

        this.zoomMode = 'zoomIn';
      },

      dragMode: 'move',
      setDragMode(dragMode) {
          this.dragMode = dragMode;
          const cropperInstance = this.cropImage.cropper;
          cropperInstance.setDragMode(dragMode)
      },
      zoomMode: 'zoomIn',
      zoom(zoomValue, zoomMode ) {
          this.zoomMode = zoomMode;
          const cropperInstance = this.cropImage.cropper;
          cropperInstance.zoom(zoomValue)
      },
      setRadius() {

         let cropperPreviewEL = document.querySelector('.js-img-cropper-preview');
        
        this.shouldPushRounded = true;
        cropperPreviewEL.classList.add("rounded");
        document.querySelector(".cropper-view-box")?.classList.add("rounded");
        document.querySelector(".cropper-face")?.classList.add("rounded");
      },
      setSquare() {
           let cropperPreviewEL = document.querySelector('.js-img-cropper-preview');

          this.shouldPushRounded = false;
          cropperPreviewEL.classList.remove("rounded");
          document.querySelector(".cropper-view-box")?.classList.remove("rounded");
          document.querySelector(".cropper-face")?.classList.remove("rounded");
      },
      
      aspectRatio: '1',
      setAspectRatio(aspectRatio) {
        this.aspectRatio = aspectRatio;
        if(aspectRatio) {
            const cropperInstance = this.cropImage.cropper;
            cropperInstance.setAspectRatio(parseFloat(aspectRatio))
        }
      },
      
    
      clear() {
        const cropperInstance = this.cropImage.cropper;
        cropperInstance.clear()
      },
      destroyCropper() {
        this.cropImage?.cropper?.destroy();
      },
      async crop() {
        return new Promise((resolve, reject) => {
          const cropperInstance = this.cropImage.cropper;
          let self = this;
          const croppedCanvas = cropperInstance.getCroppedCanvas();
          let finalCanvas = croppedCanvas;
          if (self.shouldPushRounded) {
              finalCanvas = self.getRoundedCanvas(croppedCanvas);
          }
          finalCanvas.toBlob(blob => {
              if (blob) {
                const dt = new DataTransfer();
                dt.items.add(new File([blob], self.cropImage.alt, { type: blob.type }));
                resolve(dt.files);
              } else {
                reject("Failed to generate blob");
              }
          });    
        });
      },
      async processUpload($store) {
          let self = this;
          
          try {
            
            const dtFiles = await this.crop();

            this.currentEl.files = dtFiles;

            if(this.currentEl.files.length) {
              const cropperData = Object.assign({
                  originalFileDataUrl: self.cropImage.src, 
                  wasAspectRatioSaved: self.shouldCurrentAspectRatioSaved,
                  aspectRatio: self.aspectRatio,
                  shouldPushRounded: self.shouldPushRounded,
                  zoomMode: self.zoomMode,
                  dragMode: self.dragMode
              } ,
                  self.cropImage?.cropper.getData()
              );
              
            
              let imageType;

              if(this.fileType === 'backgrounds') {
                    imageType = 'BACKGROUND'
              } else if (this.fileType === 'shapes') {
                    imageType = 'SHAPE'
              }

              const uploadObj = {
                  files: this.currentEl.files,
                  action: `${window.apiInfo[window.apiTestMode].url}/api/v1/product-configurators/${$store.canvas.configuratorId || null}/images`,
                  type: `${this.fileType}[]`,
                  imageType: imageType,
                  originalFile: this.originalImageFile, 
                  cropperData: cropperData
              }

              const data = await $store.uploadStore.uploadFilesToServer(uploadObj);

              data?.data?.images?.forEach((image) => {
                  const detailObj = {
                    detail: {}
                  }

                  detailObj.detail[this.fileType] = [image]

                  window.dispatchEvent(new CustomEvent(`${this.fileType}-added-from-api`, detailObj));
              });
            }

          } catch (error) {
             console.log(error);
          }
      },
      getDataUrlFromFile(file) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
          });
      },
      async processUploadWithoutCrop($store, fileType, files) {
        

        let imageType;

        if(fileType === 'backgrounds') {
            imageType = 'BACKGROUND'
        } else if (fileType === 'shapes') {
            imageType = 'SHAPE'
        }

        for (const file of files) {
              const dataUrl = await this.getDataUrlFromFile(file)

              const uploadObj = {
                files: [file],
                action: `${window.apiInfo[window.apiTestMode].url}/api/v1/product-configurators/${$store.canvas.configuratorId || null}/images`,
                type: `${fileType}[]`,
                imageType: imageType,
                originalFile: file, 
                cropperData: {
                  originalFileDataUrl: dataUrl, 
                  wasAspectRatioSaved: false,
                  aspectRatio:  '1',
                  shouldPushRounded: false,
                  zoomMode: 'zoomIn',
                  dragMode: 'move'
                }
              }

              try {
                const data = await $store.uploadStore.uploadFilesToServer(uploadObj);
  
                data?.data?.images?.forEach((image) => {
                    const detailObj = {
                      detail: {}
                    }
  
                    detailObj.detail[fileType] = [image]
  
                    window.dispatchEvent(new CustomEvent(`${fileType}-added-from-api`, detailObj));
                });

              } catch (error) {
                console.log(error);
              }

        }
       

      },
      async processUpdate($store) {
        let self = this;
        const files = await this.crop();
        
        this.currentEl.files = files;


        const cropperData = Object.assign({
          originalFileDataUrl: self.cropImage.src,
          wasAspectRatioSaved: self.shouldCurrentAspectRatioSaved,
          aspectRatio: self.aspectRatio,
          shouldPushRounded: self.shouldPushRounded,
          zoomMode: self.zoomMode,
          dragMode: self.dragMode
        } ,
          self.cropImage?.cropper.getData()
        );
        if(this.currentEl.files.length) {
          const editUploadObj = {
            files: this.currentEl.files,
            action: `${window.apiInfo[window.apiTestMode].url}/api/v1/product-configurators/images/${this.editingImageId}`,
            type: 'image',
            cropperData: cropperData
          }
          const data = await $store.uploadStore.updateImageInServer(editUploadObj);

          //here for update case background is directly returned as data.data and no further background property under that
          if(data?.data) {
            const detailObj = {
              detail: {}
            }
            
            detailObj.detail[this.fileType] = [data?.data]

            window.dispatchEvent(new CustomEvent(`${this.fileType}-updated-from-api`, detailObj));
          }
        }
      },
      getRoundedCanvas(sourceCanvas,aspectRatio) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var width = sourceCanvas.width;
        var height = sourceCanvas.height;
        if (width > 0 && height > 0) { 
            if (width / height > aspectRatio) {
                var newWidth = height * aspectRatio;
                var xOffset = (width - newWidth) / 2;
                canvas.width = newWidth;
                canvas.height = height;
                context.drawImage(sourceCanvas, xOffset, 0, newWidth, height, 0, 0, newWidth, height);
            } else {
                canvas.width = width;
                canvas.height = height;
                context.drawImage(sourceCanvas, 0, 0, width, height, 0, 0, width, height);
            }
            context.imageSmoothingEnabled = true;
            context.globalCompositeOperation = 'destination-in';
            var centerX = canvas.width / 2;
            var centerY = canvas.height / 2;
            var radiusX = canvas.width / 2;
            var radiusY = canvas.height / 2;
            context.beginPath();
            context.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, 2 * Math.PI);
            context.fill();
        }
        return canvas;
    },
      shouldCurrentAspectRatioSaved: false,
      populateAspectRatio(shapeOrPictureObj) {
            
          if(shapeOrPictureObj.cropperData && shapeOrPictureObj.cropperData.wasAspectRatioSaved) {
              const width = shapeOrPictureObj.cropperData.width;
              const height = shapeOrPictureObj.cropperData.height;

              if (width > 0 && height > 0) {
                  const aspectRatioLabel = calculateAspectRatio(parseInt(width), parseInt(height))
                  const aspectRatioValue = (width / height).toFixed(2);

                  // prevent repushing the same ratio
                  if(!(this.savedAspectRatios.find(savedAspectRatio => savedAspectRatio.value === aspectRatioValue))) {
                      this.savedAspectRatios.push({
                          label: aspectRatioLabel,
                          value: aspectRatioValue
                      })
                  }
              }
          }
      },

      savedAspectRatios: [{
          label: '16:10',
          value: 1.6
      }, {
          label: '5:4',
          value: 1.25
      }],
    })
   
     
});
     
      
